import { render, staticRenderFns } from "./ActionPostbackTag.vue?vue&type=template&id=3a69f530&"
import script from "./ActionPostbackTag.vue?vue&type=script&lang=js&"
export * from "./ActionPostbackTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports